export default __webpack_public_path__ + "static/good-health-and-well-being-6998b1bccc5f3d9b64ded961468c5946.png";